export const ensureModalRoot = () => {
  if (typeof document === "undefined") return null;

  let root = document.getElementById("modal-root");
  if (!root) {
    root = document.createElement("div");
    root.setAttribute("id", "modal-root");
    document.body.appendChild(root);
  }

  return root;
};

